<template>
  <el-card shadow="never">
    <template slot="header">
      <el-steps :active="active" align-center>
        <el-step title="Choose payment method"></el-step>
        <el-step title="Details"></el-step>
      </el-steps>
    </template>
    <el-card v-if="active === 0" shadow="never">
      <div>
        <el-radio-group v-model="paymentType" border>
          <el-radio-button label="Bank"></el-radio-button>
          <el-radio-button label="Credit Card"></el-radio-button>
        </el-radio-group>
      </div>
      <el-divider></el-divider>
      <el-button @click="() => active += 1">Next</el-button>
    </el-card>
    <el-card v-if="active === 1" shadow="never">
      <CreditCard v-if="paymentType === 'Credit Card'" @added-card="() => $emit('added-card')" :customer-id="customerId">
      </CreditCard>
      <USBankForm v-else @bank-added="() => $emit('added-bank')" :customer-id="customerId" :customer="customer">
      </USBankForm>
      <el-divider></el-divider>
      <el-button @click="() => active -= 1">Back</el-button>
      <el-button @click="() => $emit('close')">Cancel</el-button>
    </el-card>
  </el-card>
</template>

<script>
import CreditCard from './CreditCardForm.vue';
import USBankForm from './USBankForm.vue';

export default {
  name: 'CustomerAddPayment',
  components: { CreditCard, USBankForm },
  props: {
    customerId: { type: String, required: true },
    customer: { type: Object, default: () => {} },
  },
  data() {
    return {
      active: 0,
      paymentType: 'Credit Card',
    };
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CustomerAddPayment.vue